module.exports = __webpack_public_path__ + "img/Benedetta.7a8e32b.png";